/**
 * <<uppercase_module_name>> Module
 */
import Vue from "vue";
import Vuex from "vuex";
import api from "Api";
import router from "Router";
import app from "Main";

// import the api endpoints
import { getForms, getForm, printForm, createForms, updateForms, deleteForms, getFormZip } from "Core/configuration/developer/config/api.forms";

const state = {
    page: {},
    form: {},
    forms: [],
    form_options: [],
    selectedForm: {
        form_id: null,
        company_id: "",
        form_date: "",
        reference_number: "",
        status_id: "",
        billing_address_id: "",
        shipping_address_id: "",
        comments: "",
        form_details: [],
    },
    forms_filter: {
        search: "",
        page_size: 2,
        page_num: 1,
    },
    rules_forms: {
        form_id: {
            name: "form_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        primary_table_id: {
            name: "primary_table_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        sub_form_id: {
            name: "sub_form_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        name: {
            name: "name",
            rules: "trim|max_length[1024]|required|regex_match[a-z_]",
            max_len: "1024",
            min_len: "",
            default_value: "",
        },
        singular_obj: {
            name: "singular_obj",
            rules: "trim|max_length[65]|required|regex_match[a-zA-Z_]",
            max_len: "65",
            min_len: "",
            default_value: "",
        },
        plural_obj: {
            name: "plural_obj",
            rules: "trim|max_length[65]|required|regex_match[a-zA-Z_]",
            max_len: "65",
            min_len: "",
            default_value: "",
        },
        endpoint: {
            name: "endpoint",
            rules: "trim|max_length[255]",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
        has_scope: {
            name: "has_scope",
            rules: "trim|max_length[1]|integer|required",
            max_len: "1",
            min_len: "",
            default_value: "0",
        },
        comments: {
            name: "comments",
            rules: "trim|max_length[255]",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
        sql_form_fields: {
            field_id: {
                name: "field_id",
                rules: "trim|max_length[15]|integer",
                max_len: "15",
                min_len: "",
                default_value: "",
            },
            name: {
                name: "name",
                rules: "trim|max_length[65]|regex_match[a-z0-9_]|required",
                max_len: "65",
                min_len: "",
                default_value: "",
            },
            input_type: {
                name: "input_type",
                rules: "trim|max_length[45]|required",
                max_len: "45",
                min_len: "",
                default_value: "",
            },
            rules: {
                name: "rules",
                rules: "trim|max_length[255]",
                max_len: "255",
                min_len: "",
                default_value: "",
            },
            min_len: {
                name: "min_len",
                rules: "trim|max_length[8]|numeric[0]",
                max_len: "8",
                min_len: "",
                default_value: "",
            },
            max_len: {
                name: "max_len",
                rules: "trim|max_length[8]|numeric[0]",
                max_len: "8",
                min_len: "",
                default_value: "",
            },
            default_value: {
                name: "default_value",
                rules: "trim|max_length[25]",
                max_len: "25",
                min_len: "",
                default_value: "",
            },
            comments: {
                name: "comments",
                rules: "trim|max_length[255]",
                max_len: "255",
                min_len: "",
                default_value: "",
            },
        },
    },
};

// getters
const getters = {
    forms: (state) => {
        return state.forms;
    },
};

// actions
const actions = {
    async fetchForms({ rootState, commit, dispatch }, payload = null) {
        try {
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            const response = await getForms({ body: body, headers: config.headers });

            if (typeof response !== "undefined" && response.data) {
                if (response.data.page) {
                    commit("mutate", {
                        property: "page",
                        with: response.data.page,
                    });
                }

                if (body.options) {
                    commit("mutate", {
                        property: "form_options",
                        with: response.data.sql_forms,
                    });
                } else {
                    commit("mutate", {
                        property: "forms",
                        with: response.data.sql_forms,
                    });
                }

                return response.data;
            } else {
                console.log("fetch all response error");
                return;
            }
        } catch (error) {
            console.log("fetch all error");
            return;
        }
    },
    async fetchForm({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await getForm(payload.id);

            if (typeof response !== "undefined" && response.data) {
                commit("mutate", {
                    property: "selectedForm",
                    with: response.data.sql_forms,
                });
                return response.data;
            } else {
                console.log("fetch response error");
                return;
            }
        } catch (error) {
            console.log("fetch single error");
            return;
        }
    },
    async fetchFormDownload({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await getFormZip({ body: body, headers: config.headers });
            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("fetch response error");
                return;
            }
        } catch (error) {
            console.log("fetch single error");
            return;
        }
    },
    async printForm({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await printForm(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("fetch print response error");
                return;
            }
        } catch (error) {
            console.log("print error");
            return;
        }
    },
    async saveForm({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            if (typeof body["form_id"] === "undefined" || body["form_id"] == null || body["form_id"] == "") {
                delete body["form_id"];
                response = await createForms({ body: body, headers: config.headers });
            } else {
                let form_id = body["form_id"];
                delete body["form_id"];
                response = await updateForms({ body: body, headers: config.headers }, form_id);
            }

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("save response error");
                return;
            }
        } catch (error) {
            console.log("save error");
            return;
        }
    },
    async deleteForm({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await deleteForms(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("delete response error");
                return;
            }
        } catch (error) {
            console.log("delete error");
            return;
        }
    },
};

// mutations
const mutations = {
    mutate(state, payload) {
        state[payload.property] = payload.with;
    },
    resetForms(state) {
        state.page = {};
        state.form = {};
        state.forms = [];
        state.form_options = [];
        state.selectedForm = {
            form_id: null,
            company_id: "",
            form_date: "",
            reference_number: "",
            status_id: "",
            billing_address_id: "",
            shipping_address_id: "",
            comments: "",
            form_details: [],
        };
        state.forms_filter = {
            search: "",
            page_size: 2,
            page_num: 1,
        };
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
